import { Component, signal } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';

interface MosqueItem { name: string; location: string; distance: string; }
interface PrayerItem { name: string; time: string; }

@Component({
  selector: 'app-qibla-finder',
  imports: [TranslatePipe],
  templateUrl: './qibla-finder.component.html',
  styleUrl: './qibla-finder.component.scss'
})
export class QiblaFinderComponent {
  protected readonly qiblaBearing = 293;
  protected readonly locationName = 'Bengaluru, Karnataka, India';
  protected readonly locationCoords = '12.9716° N, 77.5946° E';
  protected readonly distanceToMakkah = '4,282 km';
  protected readonly lastUpdated = 'Today, 10:30 AM';

  protected get needleRotation(): number { return this.qiblaBearing; }

  protected voiceEnabled = signal(false);
  protected calibrating = signal(false);

  protected readonly nearbyMosques: MosqueItem[] = [
    { name: 'Masjid-e-Noor',  location: 'Bengaluru, KA', distance: '1.2 km' },
    { name: 'Masjid Al-Huda', location: 'Bengaluru, KA', distance: '2.8 km' },
    { name: 'Masjid Usman',   location: 'Bengaluru, KA', distance: '3.6 km' },
  ];

  protected readonly prayerTimes: PrayerItem[] = [
    { name: 'Fajr',    time: '05:04 AM' },
    { name: 'Dhuhr',   time: '12:20 PM' },
    { name: 'Asr',     time: '03:45 PM' },
    { name: 'Maghrib', time: '06:42 PM' },
    { name: 'Isha',    time: '08:02 PM' },
  ];

  protected readonly compassPoints = [
    { label: 'N',  deg: 0   },
    { label: 'NE', deg: 45  },
    { label: 'E',  deg: 90  },
    { label: 'SE', deg: 135 },
    { label: 'S',  deg: 180 },
    { label: 'SW', deg: 225 },
    { label: 'W',  deg: 270 },
    { label: 'NW', deg: 315 },
  ];

  protected readonly tickCount = 72;

  protected calibrate(): void {
    this.calibrating.set(true);
    setTimeout(() => this.calibrating.set(false), 2000);
  }

  protected toggleVoice(): void {
    this.voiceEnabled.update(v => !v);
  }
}
